import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { Save, Loader2, Compass } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function GaugeSuggestionsPanel() {
  const { data, refetch } = useQuery({ queryKey: ["admin-gauge-suggestions"], queryFn: () => api.get("/admin/gauge/suggestions").then((r) => r.data) });
  const [dims, setDims] = useState([]);
  const [saving, setSaving] = useState("");

  useEffect(() => { if (data) setDims(data.map((d) => ({ ...d }))); }, [data]);

  const setCatItems = (di, ci, text) => {
    setDims((prev) => prev.map((d, i) => i !== di ? d : {
      ...d, categories: d.categories.map((c, j) => j !== ci ? c : { ...c, items: text.split("\n").map((s) => s.trim()).filter(Boolean) }),
    }));
  };
  const setField = (di, key, val) => setDims((prev) => prev.map((d, i) => i !== di ? d : { ...d, [key]: val }));

  const save = async (dim) => {
    setSaving(dim.dimension);
    try {
      await api.put(`/admin/gauge/suggestions/${dim.dimension}`, { label: dim.label, blurb: dim.blurb, sort_order: dim.sort_order, categories: dim.categories });
      toast.success(`${dim.label} suggestions saved`); refetch();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(""); }
  };

  return (
    <div data-testid="admin-gauge-suggestions-panel">
      <div className="mb-6"><h2 className="font-serif text-2xl text-[#1A242B] flex items-center gap-2"><Compass size={20} /> GAUGE holistic suggestions</h2><p className="text-sm text-[#4A5D6B]">Curate the Mind / Body / Emotional plan guests receive after exploring — habits, foods, herbs, meditation, nature walks, and relationship stewardship. One suggestion per line.</p></div>
      <div className="space-y-6">
        {dims.map((d, di) => (
          <div key={d.dimension} className="eyw-card p-6" data-testid={`gauge-sug-${d.dimension}`}>
            <div className="grid sm:grid-cols-2 gap-3 mb-4">
              <div><label className="text-xs text-[#4A5D6B]">Label</label><input value={d.label || ""} onChange={(e) => setField(di, "label", e.target.value)} className="eyw-input w-full text-sm" /></div>
              <div><label className="text-xs text-[#4A5D6B]">Short blurb</label><input value={d.blurb || ""} onChange={(e) => setField(di, "blurb", e.target.value)} className="eyw-input w-full text-sm" /></div>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {(d.categories || []).map((c, ci) => (
                <div key={ci}>
                  <label className="text-xs font-semibold text-[#144F75]">{c.category}</label>
                  <textarea value={(c.items || []).join("\n")} onChange={(e) => setCatItems(di, ci, e.target.value)} rows={3} data-testid={`gauge-sug-${d.dimension}-${ci}`} className="eyw-input w-full text-sm mt-1" />
                </div>
              ))}
            </div>
            <div className="flex justify-end mt-4"><button onClick={() => save(d)} disabled={saving === d.dimension} data-testid={`gauge-sug-save-${d.dimension}`} className="eyw-btn !py-2 text-sm disabled:opacity-60">{saving === d.dimension ? <Loader2 className="animate-spin" size={15} /> : <Save size={15} />} Save {d.label}</button></div>
          </div>
        ))}
      </div>
    </div>
  );
}
